import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import PrivateLayout from './Settings/PrivateLayout';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Reservations from "./pages/reservation/Reservations.jsx";
import TafelOpstelling from "./components/Settings/TafelOpstelling.jsx";
import ViewTafelOpstelling from "./pages/Table/ViewTafelOpstelling.jsx";
import Register from "./pages/humanresource/RegisterHumanResource.jsx";
import RegisterAccount from "./pages/humanresource/RegisterAccount.jsx";
import ClockIn from "./pages/ClockIn.jsx";
import Scheduler from "./components/Schedule/Scheduler.jsx";
import TimeCorrection from "./components/Schedule/NostradamusUrenCorrectie.jsx";
import RegistrationLinkDashboard from "./components/Settings/RegistrationLinkDashboard.jsx";
import EmployerDashboard from "./components/Dashboards/EmoloyerDashboard.jsx";
import LandingPage from "./pages/LandigsPage.jsx";
import EmployeeTimeDashboard from "./components/Dashboards/EmployeeTimeDashboard.jsx";
import ReportPage from "./pages/Rapportage/ReportPage.jsx";
import TimeslotManager from "./components/Settings/TimeSlotManager.jsx";
import KeepMeInformedPage  from "./pages/keepMeInformedPage.jsx";
import SettingsPage from "./pages/Settings/SettingsPage.jsx";
import ForgotPassword from "./pages/humanresource/ForgotPassword.jsx";
import ResetPassword from "./pages/humanresource/ResetPassword.jsx";
import OfferteGenerator1 from "./components/Dashboards/OfferteGenerator1.jsx";
import CourseList from './pages/elearning/CourseList';
import CourseView from './pages/elearning/CourseView';
import ProgressTracker from './pages/elearning/ProgressTracker';
import LogoUploadPage from "./components/Settings/LogoUploadPage.jsx";
import {SubscriptionProvider} from "./Settings/SubscripitionChecker.jsx";


function App() {
    const [isSidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    }

    return (
        <SubscriptionProvider>
        <Router>
            <Routes>
                {/* Openbare Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register/:token" element={<Register />} />
                <Route path="/users/register/:token" element={<RegisterAccount />}/>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<LandingPage />} />
                <Route path="/demo" element={<KeepMeInformedPage />} />
                <Route path="/forgot-password" element={<ForgotPassword/>} />
                <Route path="/reset-password/:token" element={<ResetPassword/>} />


                <Route element={<PrivateRoute />}>
                    <Route element={<PrivateLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}>

                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/schedule" element={<Scheduler />} />
                        <Route path="/reserveringen" element={<Reservations />} />
                        <Route path="/settings/tafelopstelling" element={<TafelOpstelling />} />
                        <Route path="/tafeltoewijzing" element={<ViewTafelOpstelling />} />
                        <Route path="/clockin" element={<ClockIn />} />
                        <Route path="/urencorrectie" element={ <TimeCorrection />} />
                        <Route path="/settings/RegistrationLinkDashboard" element={<RegistrationLinkDashboard />} />
                        <Route path="/Employerdashboard" element={<EmployerDashboard />} />
                        <Route path="/EmployeeTimeDashboard" element={<EmployeeTimeDashboard />} />
                        <Route path="/ReportPage" element={<ReportPage />} />
                        <Route path="/settings/TimeslotManager" element={<TimeslotManager />} />
                        <Route path="/settings" element={<SettingsPage />} />
                        <Route path="/settings/logoUpload" element={<LogoUploadPage />} />
                        <Route path="/offertegenerator" element={<OfferteGenerator1 />} />
                        <Route path="/courses" element={<CourseList />} />
                        <Route path="/courses/:courseId" element={<CourseView />} />
                        <Route path="/learning-progress" element={<ProgressTracker />} />

                    </Route>
                </Route>

            </Routes>
        </Router>
</SubscriptionProvider>
    );
}

export default App;
